<template>
    <Head title="Applicant Training"></Head>
    <div class="grid">
                <!-- Section Data stats Karyawan -->
                <div class="card col-12 md:col-7">
                    <div class="flex align-items-center">
                        <Avatar icon="pi pi-user" class="mr-2" size="xlarge" shape="circle" />
                        <span>
                            <span class="text-2xl">{{ userDetail.name }}</span>
                            <br />
                            <span>{{ userDetail.roles }}</span>
                        </span>
                    </div>
                    <div class="flex flex-wrap justify-content-between mt-3">
                        <div class="card col-6">
                            <div class="flex align-items-center">
                                <Avatar icon="pi pi-check" class="mr-2 bg-green-500 text-white" size="large" shape="circle" />
                                <span>
                                    <span class="text-md">Present</span>
                                    <br />
                                    <span>{{ summaryAttendance.present }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="card col-6">
                            <div class="flex align-items-center">
                                <Avatar icon="pi pi-times" class="mr-2 bg-pink-400 text-white" size="large" shape="circle" />
                                <span>
                                    <span class="text-md">Absent</span>
                                    <br />
                                    <span>{{ summaryAttendance.absent }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="card col-6">
                            <div class="flex align-items-center">
                                <Avatar icon="pi pi-clock" class="mr-2 bg-blue-500 text-white" size="large" shape="circle" />
                                <span>
                                    <span class="text-md">Clockout Early</span>
                                    <br />
                                    <span>{{ summaryAttendance.clockout_early }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="card col-6">
                            <div class="flex align-items-center">
                                <Avatar icon="pi pi-star" class="mr-2 bg-yellow-500 text-white" size="large" shape="circle" />
                                <span>
                                    <span class="text-md">Holiday</span>
                                    <br />
                                    <span>{{ summaryAttendance.holiday }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="card col-6">
                            <div class="flex align-items-center">
                                <Avatar icon="pi pi-sign-out" class="mr-2 bg-pink-500 text-white" size="large" shape="circle" />
                                <span>
                                    <span class="text-md">Leave</span>
                                    <br />
                                    <span>{{ summaryAttendance.leave }}</span>
                                </span>
                            </div>
                        </div>
                        <div class="card col-6">
                            <div class="flex align-items-center">
                                <Avatar icon="pi pi-exclamation-circle" class="mr-2 bg-orange-500 text-white" size="large" shape="circle" />
                                <span>
                                    <span class="text-md">late</span>
                                    <br />
                                    <span>{{ summaryAttendance.late }}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="card col-12 md:col-5">
                    <Calendar class="w-full" inline showWeek />
                </div>
        <div class="col-12">
            <div class="card">
                <Toast />
                <Toolbar class="mb-4">
                    <template v-slot:start>
                        <Button
                            label="Input New Attendance"
                            icon="pi pi-envelope"
                            class="p-button-primary mr-2"
                            @click="showNewDialog"
                        />
                    </template>
                    <template v-slot:end>
                        <Button
                                label="Print Selected Attendance"
                                icon="pi pi-print"
                                class="p-button-success mr-2"
                                @click="exportDetail"
                                :loading="isExporting"
                                :disabled="
                                    !selectedModels || !selectedModels.length || selectedModels.length > 1
                                "
                            />
                    </template>
                </Toolbar>
                <DataTable
                    ref="dt"
                    :value="models"
                    :lazy="true"
                    dataKey="id"
                    v-model:selection="selectedModels"
                    :paginator="true"
                    :rows="10"
                    :loading="loading"
                    :total-records="totalRecords"
                    v-model:filters="filters"
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    :rowsPerPageOptions="[5, 10, 25]"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} models"
                    responsiveLayout="scroll"
                    @row-select="onRowSelect"
                    @row-unselect="onRowUnselect"
                    @page="onPage($event)"
                    @sort="onSort($event)"
                >
                    <template #header>
                        <div
                            class="flex flex-column md:flex-row md:justify-content-between md:align-items-center"
                        >
                            <h5 class="m-0">Manage Attendances</h5>
                            <span class="block mt-2 md:mt-0 p-input-icon-left">
                                <i class="pi pi-search" />
                                <InputText
                                    @change="onFilter($event)"
                                    v-model="filters['global'].value"
                                    placeholder="Search..."
                                />
                            </span>
                        </div>
                    </template>

                    <Column
                        selectionMode="multiple"
                    ></Column>
                    <Column
                        field="name"
                        header="Name"
                        :sortable="true"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">Name</span>
                            {{ slotProps.data.name }}
                        </template>
                    </Column>
                    <Column
                        v-for="i in date"
                        :key="i"
                        :field="`${i}`"
                        :header="i"
                        :sortable="false"
                        headerStyle="width:1%;"
                    >
                        <template #body="slotProps">
                            <span class="p-column-title">{{ i }}</span>
                            <i :class="slotProps.data[i] ? status[slotProps.data[i]['as']] : status['unshift']"></i>
                        </template>
                    </Column>
                </DataTable>
            </div>
        </div>
    </div>
</template>

<script>
import AppLayout from "../../Layouts/AppLayout";
import { FilterMatchMode } from "primevue/api";
import { Head } from "@inertiajs/inertia-vue3";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import Toolbar from "primevue/toolbar";
import Toast from "primevue/toast";
import DataTable from "primevue/datatable";
import Column from "primevue/column";
import Dropdown from "primevue/dropdown";
import Dialog from "primevue/dialog";
import Panel from "primevue/Panel";
import Badge from "primevue/badge";
import Avatar from "primevue/avatar";
import Calendar from "primevue/calendar";
import DatatableService from "../../Services/DatatableService";
import axios from "axios";

export default {
    name: "Index",
    layout: AppLayout,
    components: {
        Head,
        Button,
        InputText,
        Toolbar,
        Toast,
        DataTable,
        Column,
        Dropdown,
        Dialog,
        Panel,
        Avatar,
        Calendar,
        Badge,
    },
    data() {
        return {
            searchFilter: "",
            filters: {},
            lazyParams: {},
            loading: true,
            totalRecords: 0,
            selectedModel: null,
            model: {},
            models: null,
            selectedModels: null,
            submitted: false,
            selectAll: false,
            isExporting: false,
            date: 0,
            summaryAttendance: this.$page.props.summary_attendance ,
            status: {
                'holiday': 'pi pi-star text-yellow-600',
                'present': 'pi pi-check text-green-600',
                'absent': 'pi pi-times text-red-600',
                'unshift': 'pi pi-ban text-red-800',
            },
            userDetail: this.$page.props.user_detail.data,
        };
    },
    datatableService: null,
    created() {
        this.datatableService = new DatatableService();
        this.initFilters();
        let date = new Date();
        this.currentDate(date.getFullYear(), date.getMonth() + 1)
    },
    mounted() {
        this.loading = true;
        this.lazyParams = {
            first: 0,
            rows: this.$refs.dt.rows,
            sortField: "id",
            sortOrder: -1,
            filters: this.filters,
        };
        this.loadLazyData();
    },
    methods: {
        showDetail(id){
            this.$inertia.get(`${this.$page.props.appUrl}attendance-views/${id}`);
        },
        showNewDialog(){
            this.$inertia.get(`${this.$page.props.appUrl}attendance-views/create`);
        },
        exportDetail(){
            this.isExporting = true;
            const rawObject = {...this.selectedModels[0]};
            axios({
                method: 'get',
                url: this.$page.props.appUrl + `api/applicant-trainings/${rawObject.id}/export`,
                responseType: 'blob'
            })
            .then((response) => {
                const href = URL.createObjectURL(response.data);
                const link = document.createElement('a');

                link.href = href;
                link.setAttribute('download','Candidate-Training.pdf');
                document.body.appendChild(link);
                link.click();

                document.body.removeChild(link);
                URL.revokeObjectURL(href);

                this.isExporting = false;
                this.$toast.add({
                    severity: "success",
                    summary: "Successful",
                    detail: "Report Exported",
                    life: 3000,
                });
            })
            .catch((error) => {
                this.isExporting = false;
                this.$toast.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error When Exporting",
                    life: 3000,
                });
            });
        },
        loadLazyData() {
            this.loading = true;

            this.lazyParams = {
                ...this.lazyParams,
                month: new Date().getMonth() + 1,
                where: {
                    id: this.userDetail.id
                },
            }

            this.datatableService
                .getData(`${this.$page.props.appUrl}api/absensi`, this.lazyParams)
                .then((data) => {
                    this.models = data.data;
                    this.totalRecords = data.total;
                    this.loading = false;
                });
        },
        onRowSelect() {
            this.selectAll = this.selectedModels.length === this.totalRecord;
        },
        onRowUnselect() {
            this.selectAll = false;
        },
        onPage(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onSort(event) {
            this.lazyParams = event;
            this.loadLazyData();
        },
        onFilter(event) {
            this.loadLazyData();
        },
        initFilters() {
            this.filters = {
                global: { value: null, matchMode: FilterMatchMode.CONTAINS, field: 'id' },
            };
        },
        currentDate(year, month) {
            this.date = new Date(year, month, 0).getDate();
        }
    },
};
</script>
<style scoped lang="scss">
@import "../../../assets/demo/badges.scss";
</style>
